import type { FilterService } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import createFilterServiceFactory from "./filter-service/factory";

const filterService: FilterService = createFilterServiceFactory();

export default filterService;
